/* eslint-disable */
<template>
  <v-container grid-list-xs,sm,md,lg,xl>


<v-layout  justify-center>
  <h1>  Welcome to Nurture Academy</h1>
</v-layout>


      <!-- <v-container> -->
        <v-layout justify-center>
          <v-card width="100%" style="padding:5%;">
            <v-form @submit.prevent="Login()">
              <v-text-field

              justify-center
              v-model="email"
              name="Email"
              placeholder="Email"></v-text-field>
              <v-text-field type="password" v-model="password" name="Password" placeholder="Password"/>
              <v-btn :loading="loading" type="submit" >Submit</v-btn>
              <v-btn v-on:click="clear()">Clear</v-btn>
            </v-form>
          </v-card>
        </v-layout>
      <!-- </v-container> -->

      <p>Don't have an account?
        <router-link to="/SignUp">Click Here</router-link>
      </p>

  </v-container>


</template>

  <script>
      /* eslint-disable */
import db from "../database";
import firebase from "firebase";
import DataLoader from "../scripts/DataLoader";

export default {
  name: "Login",
  data() {
    return {
      something: "helo",
      email: "",
      password: "",
      tempUser: "",
      loader: null,
      loading: false,
        students:'meow',
        // hello:this.loadData()
    };
  },
  firestore() {
    return {
      fireuser: db.collection("Users"),
        // students: this.loadData()

    };
  },
  mounted() {
    let self = this;
  },
  watch: {
    loader() {
      //for loading button.
      const l = this.loader;
      this[l] = !this[l];
    },
    $route() {
      this.breadcrumbList = this.$route.meta.breadcrumb;
    }
  },
  methods: {
//       loadData(){
//           var loader = new DataLoader();
// // students: loader.GetStudents();
//         // return loader.GetStudents().get();
//       },
    clear() {
      console.log("Clearing text");
      this.email = "";
      this.password = "";
      this.loading = false;
    },
// test(){
//     let meow = new DataLoader();
//     var students=meow.GetStudents();
//     students.get().then(function(snapshot){
//         snapshot.forEach(function(doc){
//             console.log(doc.id,"=>",doc.data())
//         });
//     })
//         .catch(function(error){
//             console.log("ERRORZ: ", error)
//         })
// },
    Login() {
      this.loading = true;
      console.log("Hello " + this.email);


        let self = this;
        firebase
          .auth()
          .signInWithEmailAndPassword(this.email, this.password)
          .then(function(user) {
            if (user) {
              var email = user.user.email;
              var id = user.user.uid;

              let UserRef = db.collection("Users").doc(id);
              let tryUser = UserRef.get().then(doc =>{
                if(doc.exists){
                  var tempUser = doc.data();
                  if(tempUser.isAdmin){
                    console.log("isAdmin!")
                  self.$router.replace({name: "AdminDash", params:{uid:id}});
                  }
                  else{
                    console.log("no admin :(")
                  self.$router.replace({name: "MainPage", params:{uid:id}});
                  }

                }
              })


            }
          })
          .catch(function(error) {
            // Handle Errors here.
              self.loading=false;
            var errorCode = error.code;
            var errorMessage = error.message;
            console.log(errorCode);
            console.log(errorMessage);
            self.$toasted.show(errorMessage);
          });



    }
  }

};
</script>
